import { render } from "./calendarView.vue?vue&type=template&id=194af4c1"
import script from "./calendarView.vue?vue&type=script&lang=js"
export * from "./calendarView.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__